/* eslint-disable react-hooks/exhaustive-deps */
import { Autocomplete, Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, Drawer, FormControl, FormControlLabel, FormGroup, Grid, IconButton, InputAdornment, InputLabel, Link, MenuItem, OutlinedInput, Select, styled, Tab, Tabs, TextField, Tooltip, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import SettingsIcon from '@mui/icons-material/Settings';
import { Add, CancelOutlined, DeleteOutline, EditOutlined } from "@mui/icons-material";
import DataTable from "../../../../common/DataTable";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../../common/common";
import { orgColumn } from "./ColumnDefs";
import { LoadingPage } from "../../../../common/LoadingPage";
import { isDateWithinNext15Days, OrgType, plans } from "../../../../common/const";
import moment from "moment";
import Users from "./user";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { useSelector } from "react-redux";
import Reports from "../../Project/ReportModule";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ImportData from "./ImportData";
import CustomField from "./CustomField";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const DemoTabs = styled(Tabs)(({ theme }) => ({
    minWidth: 200,
    borderBottom: '2px solid #e8e8e8',
    [theme.breakpoints.down('xs')]: {
        marginLeft: '0%',
    },
    [theme.breakpoints.down('md')]: {
        minWidth: '20px',
        fontSize: 10,
    },
}));

const DemoTab = styled(Tab)(({ theme }) => ({
    minWidth: 110,
    fontSize: 18,
    textTransform: 'capitalize',
    fontFamily: 'open sans',
    fontWeight: 'bold',
    [theme.breakpoints.down('xs')]: {
        minWidth: 8,
        fontSize: 10,
    },
    '&:hover': {
        backgroundColor: '#f6f7ff',
        color: 'black',
    },
}));

const SoftwareAdminPanel = ({
    isUser
}) => {
    const { user, roles } = useSelector(state => state.users);
    const [activeTab, setActiveTab] = useState(0);
    const [searchingText, setSearchText] = useState(null);
    const [rowsPerPage, setRowPerPage] = useState(10);
    const [gridApi, setGridApi] = useState(null);
    const [dataLoading, setDataLoding] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [organizationId, setOrganizationId] = useState(null);
    const [activetab, setActivetab] = useState(0);
    const [organizationName, setOrganizationName] = useState(null);
    const [organizationType, setOrganizationType] = useState(null);
    const [orgWebsite, setOrgWebsite] = useState(null);
    const [orgPhone, setOrgPhone] = useState(null)
    const [errors, setErrors] = useState({});
    const [planId, setPlanId] = useState(null);
    const [subscriptionId, setSubscriptionId] = useState(null);
    const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
    const [isProcurementAssign, setIsProcurementAssign] = useState(false);
    const [userCount, setUserCount] = useState(0);
    const [rowData, setRowData] = useState([]);
    const [userOpen, setUserOpen] = useState(false);
    const [orgData, setOrgData] = useState(null);
    const [reportSetting, setReportSetting] = useState(false);
    const [manufacturerData, setManufacturerData] = useState([]);
    const [manufacturerPage, setManufacturerPage] = useState(1);
    const [isManufacturerAvailable, setIsManufacturerAvailable] = useState(true);
    const [manufacturerLoading, setManufacturerLoading] = useState(false);
    const [inputValue, setInputValue] = useState('');
    const [suppliers, setSupplier] = useState([]);

    const onPaginationChanged = (event) => {
        if (event.api) {
            const newPageSize = event.api.paginationGetPageSize();
            setRowPerPage(newPageSize);
        }
    };

    const getManufacturerData = async (pageNo, searchText) => {
        try {
            setManufacturerLoading(true);
            const response = await apiRequest('get', `/product-provider?&pageNo=${pageNo}&pageSize=10&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsManufacturerAvailable(true);
                const array = [...manufacturerData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setManufacturerData(uniqueArray);
                setManufacturerLoading(false);
            } else {
                setIsManufacturerAvailable(false);
                setManufacturerLoading(false);
            }
        } catch (error) {
            setManufacturerLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const loadNextManufacturer = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = manufacturerPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isManufacturerAvailable) {
            setManufacturerPage(numberOfPages);
            await getManufacturerData(numberOfPages);
        }
    };

    const onGridReady = useCallback((params) => {
        if (params?.api) {
            const { api, searchingText } = params;
            setGridApi(api);
            setDataLoding(true);
            const dataSource = {
                rowCount: null,
                getRows: async (params) => {
                    const url = [
                        '/admin/organizations?',
                        `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
                        `pageSize=${rowsPerPage}`,
                        searchingText ? `searchText=${encodeURIComponent(searchingText)}` : ''
                    ]
                        .filter(Boolean)  // Filters out empty strings
                        .join('&');
                    try {
                        const response = await apiRequest('get', `${url}`);
                        const { data, total_count } = response.data;
                        let lastRow = -1;
                        if (data?.length <= total_count) {
                            lastRow = total_count;
                        }
                        params.successCallback(data, lastRow);
                    } catch (error) {
                        setDataLoding(false);
                        showNotification(error?.response?.data.error || error.message, 'error');
                    }
                    setDataLoding(false);
                },
            };
            api.setGridOption("datasource", dataSource);
            setTimeout(() => {
                const node = api.getRenderedNodes();
                if (!node?.[0]?.displayed) {
                    api.showNoRowsOverlay();
                }
            }, 5000);
        }
    }, [rowsPerPage, gridApi]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            if (activeTab === 1) {
                onGridReady({
                    api: gridApi,
                });
            }
        }
        return () => {
            isMounted = false;
        };
    }, [rowsPerPage, gridApi]);

    const updatedColumns = useMemo(() => {
        let column = orgColumn;
        if (column.length > 0) {
            return column.map((col) => {
                if (col.field === '_count') {
                    return {
                        ...col,
                        minWidth: 100,
                        width: 100,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <Link
                                style={{
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    color: isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date) ? 'red' : ''
                                }}
                                onClick={() => {
                                    setOrgData(params?.data);
                                    setOrganizationId(params?.data?.organization_id);
                                    setUserOpen(true);
                                }}
                            >
                                {params?.data?.["_count"]?.user}
                            </Link>
                        ),
                    };
                }
                if (col.field === 'max_user') {
                    return {
                        ...col,
                        width: 100,
                        minWidth: 100,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.Subscriptions[0]?.user_limit || 0}</span>
                        ),
                    };
                }
                if (col.field === 'org_type') {
                    return {
                        ...col,
                        width: 120,
                        minWidth: 120,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{OrgType.find((a) => a.value === params?.data?.org_type)?.label}</span>
                        ),
                    };
                }
                if (col.field === 'created_at') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.created_at ? moment(params?.data?.created_at).format('DD-MM-YYYY') : '--'}</span>
                        ),
                    };
                }
                if (col.field === 'org_phone_number') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.org_phone_number || '--'}</span>
                        ),
                    };
                }
                if (col.field === 'org_name') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <Link
                                style={{
                                    textDecoration: 'none',
                                    cursor: 'pointer',
                                    color: isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date) ? 'red' : ''
                                }}
                                onClick={() => {
                                    setOrgData(params?.data);
                                    setOrganizationId(params?.data?.organization_id);
                                    setUserOpen(true);
                                }}
                            >
                                {params?.data?.org_name}
                            </Link>
                        )
                    };
                }
                if (col.field === 'license') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{plans.find((a) => a.value === params?.data?.Subscriptions[0]?.plan_id)?.label || '--'}</span>
                        ),
                    };
                }
                if (col.field === 'startdate') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.Subscriptions[0]?.start_date ? moment(params?.data?.Subscriptions[0]?.start_date).format('DD-MM-YYYY') : '--'}</span>
                        ),
                    };
                }
                if (col.field === 'enddate') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.Subscriptions[0]?.end_date ? moment(params?.data?.Subscriptions[0]?.end_date).format('DD-MM-YYYY') : '--'}</span>
                        ),
                    };
                }
                if (col.field === 'org_status') {
                    return {
                        ...col,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <span>{params?.data?.Subscriptions[0]?.plan_id ? 'Active' : 'In Active'}</span>
                        ),
                    };
                }
                if (col.field === 'action') {
                    return {
                        ...col,
                        minWidth: 150,
                        width: 150,
                        cellStyle: (params) => {
                            if (isDateWithinNext15Days(params?.data?.Subscriptions[0]?.end_date)) {
                                return {
                                    color: 'red',
                                    background: 'yellow',
                                }
                            }
                            return {
                                background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                            };
                        },
                        cellRenderer: (params) => (
                            <>
                                <Tooltip title="Edit Organization">
                                    <EditOutlined
                                        color="primary"
                                        style={{ cursor: 'pointer', color: isUser?.code !== 'mvedasMasterAdmin' ? 'gray' : '' }}
                                        onClick={() => {
                                            if (isUser?.code === 'mvedasMasterAdmin') {
                                                setDialogOpen(true);
                                                setOrganizationId(params?.data?.organization_id);
                                            }
                                        }}
                                    />
                                </Tooltip>
                                <Tooltip title="Delete Organization">
                                    <DeleteOutline
                                        color="secondary"
                                        style={{ cursor: 'pointer', color: isUser?.code !== 'mvedasMasterAdmin' ? 'gray' : '', marginLeft: 5 }}
                                        onClick={() => {
                                            if (isUser?.code === 'mvedasMasterAdmin') {
                                                setDeleteOpen(true);
                                                setOrganizationId(params?.data?.organization_id);
                                            }
                                        }}
                                    />
                                </Tooltip>
                                <Tooltip title="Store Report Setting">
                                    <SettingsIcon
                                        color="primary"
                                        style={{ marginLeft: 5 }}
                                        onClick={() => {
                                            setOrganizationId(params?.data?.organization_id);
                                            setReportSetting(true);
                                        }}
                                    />
                                </Tooltip>
                                {params?.data?.Subscriptions[0]?.plan_id && (
                                    <Tooltip title="Cancel License">
                                        <CancelOutlined
                                            style={{ cursor: 'pointer', color: isUser?.code !== 'mvedasMasterAdmin' ? 'gray' : '', marginLeft: 5 }}
                                            color="primary"
                                            onClick={async () => {
                                                if (isUser?.code === 'mvedasMasterAdmin') {
                                                    setDataLoding(true);
                                                    const response = await apiRequest('delete', `/subscription/${params?.data?.organization_id}`);
                                                    if (response?.data) {
                                                        setDataLoding(false);
                                                        onGridReady({
                                                            api: gridApi
                                                        })
                                                        showNotification('License cancelled successfully', 'success');
                                                    }
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </>
                        ),
                    };
                }
                return col;
            })
        }
        return column;
    }, [orgColumn, gridApi]);

    const getOrganization = async () => {
        const response = await apiRequest('get', `/organization/${organizationId}`);
        const res = await apiRequest('get', `/admin/org-suppliers/${organizationId}`);
        const { data } = response.data;
        setOrganizationName(data?.org_name);
        setOrgPhone(data?.org_phone_number);
        setOrgWebsite(data?.org_website);
        setSupplier(res?.data?.data?.map((a) => a.product_provider_id) || []);
        setOrganizationType(data?.org_type);
        const subscritionRes = await apiRequest('get', `/subscription?organizationId=${organizationId}&pageNo=1&pageSize=100`);
        if (subscritionRes.data) {
            setRowData(subscritionRes.data.data);
            const activeSubscription = subscritionRes.data.data.filter((a) => a.status === 'active');
            setSubscriptionId(activeSubscription[0]?.subscriptions_id);
            setPlanId(plans.find((a) => a.value === activeSubscription[0]?.plan_id));
            setUserCount(activeSubscription[0]?.user_limit);
            setIsProcurementAssign(activeSubscription[0]?.is_procurement_assign);
            setStartDate(moment(activeSubscription[0]?.start_date).format('YYYY-MM-DD'));
            setEndDate(moment(activeSubscription[0]?.end_date).format('YYYY-MM-DD'));
        }
    }

    useEffect(() => {
        if (dialogOpen && organizationId) {
            getOrganization();
        }
        if (dialogOpen) {
            getManufacturerData(manufacturerPage);
        }
    }, [dialogOpen]);
    return (
        <>
            {dataLoading && <LoadingPage isLoading={dataLoading} />}
            <Drawer
                anchor="bottom"
                open={reportSetting}
                sx={{
                    '& .MuiDrawer-paper': {
                        height: '85%',
                        padding: 2
                    }
                }}
            >
                {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                <Reports
                    organizationId={organizationId}
                    fromAdmin
                    setReportSetting={setReportSetting}
                />
            </Drawer>
            {userOpen && (
                <Users
                    userOpen={userOpen}
                    organizationId={organizationId}
                    isUser={isUser}
                    setUserOpen={setUserOpen}
                    getOrganization={() => {
                        onGridReady({
                            api: gridApi
                        })
                    }}
                    orgData={orgData}
                    setOrgData={setOrgData}
                />
            )}
            <Dialog open={deleteOpen} fullWidth maxWidth="xs">
                <DialogContent>Are you sure to delete this one?</DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" color="secondary"
                        onClick={() => {
                            setOrganizationId(null);
                            setDeleteOpen(false);
                        }}
                    >
                        No
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            try {
                                setDataLoding(true);
                                const response = await apiRequest('delete', `/admin/organization/${organizationId}`);
                                if (response?.data) {
                                    setDataLoding(false);
                                    showNotification(response?.data?.message, 'success');
                                    setOrganizationId(null);
                                    setDeleteOpen(false);
                                    onGridReady({
                                        api: gridApi
                                    });
                                }
                            } catch (error) {
                                setDataLoding(false);
                                showNotification(error?.response?.data.error || error.message, 'error');
                            }
                        }}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={dialogOpen} fullWidth maxWidth="md">
                <DialogContent>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <DemoTabs
                            value={activetab}
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <DemoTab
                                label="Organization"
                                value={0}
                                onClick={() => {
                                    setActivetab(0);
                                }} />
                            <DemoTab
                                label="Subscription"
                                value={1}
                                onClick={() => {
                                    setActivetab(1);
                                }} />
                        </DemoTabs>
                    </Box>
                    {activetab === 0 && (
                        <Grid container spacing={1} mt={1}>
                            <Grid item sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Name <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="Organization Name"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={organizationName || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.organization = '';
                                                newErrors.organizationName = '';
                                            } else {
                                                newErrors.organizationName = 'Organization Name is required'
                                            }
                                            setErrors(newErrors);
                                            setOrganizationName(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.organizationName}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Type <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        label="Organization Type"
                                        value={organizationType || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.organization = '';
                                                newErrors.organizationType = '';
                                            } else {
                                                newErrors.organizationType = 'Organization Type is required'
                                            }
                                            setErrors(newErrors);
                                            setOrganizationType(e.target.value);
                                        }}
                                    >
                                        {OrgType.map((a) => (
                                            <MenuItem value={a.value}>{a.label}</MenuItem>
                                        ))}
                                    </Select>
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.organizationType}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Phone Number</InputLabel>
                                    <OutlinedInput
                                        label="Organization Phone Number"
                                        id="standard-adornment-password"
                                        type='number'
                                        value={orgPhone || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            setOrgPhone(e.target.value)
                                            const phoneRegex = /^(?:\+?(\d{1,2}))?[-.\s]?(\(?\d{3}\)?)[-.\s]?\d{3}[-.\s]?\d{4}$/;
                                            if (phoneRegex.test(e.target.value)) {
                                                newErrors.orgPhone = '';
                                            } else if (!e.target.value) {
                                                newErrors.orgPhone = '';
                                            } else {
                                                newErrors.orgPhone = 'Please provide valid phone number';
                                            }
                                            setErrors(newErrors);
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.keyCode === 38 || event.keyCode === 40) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.orgPhone}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Organization Website</InputLabel>
                                    <OutlinedInput
                                        label="Organization Website"
                                        id="standard-adornment-password"
                                        type='text'
                                        value={orgWebsite || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            const websiteRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/;
                                            if (websiteRegex.test(e.target.value)) {
                                                newErrors.orgWebsite = '';
                                            } else if (!e.target.value) {
                                                newErrors.orgWebsite = '';
                                            } else {
                                                newErrors.orgWebsite = 'Please provide valid website';
                                            }
                                            setErrors(newErrors);
                                            setOrgWebsite(e.target.value);
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.orgWebsite}</Typography>
                                </FormControl>
                            </Grid>
                        </Grid>
                    )}
                    {activetab === 1 && (
                        <Grid container spacing={1} mt={1}>
                            <Grid item sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">License <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        id="demo-simple-select-standard"
                                        label="License"
                                        value={planId || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.plan = '';
                                                newErrors.plan = '';
                                            } else {
                                                newErrors.plan = 'Please select license'
                                            }
                                            setErrors(newErrors);
                                            setPlanId(e.target.value);
                                            if (['Student', 'Supplier'].includes(e.target.value.label)) {
                                                setIsProcurementAssign(false);
                                            }
                                        }}
                                    >
                                        {plans.map((a) => (
                                            <MenuItem value={a}>{a.label}</MenuItem>
                                        ))}
                                    </Select>
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.plan}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password"># Of Users <span style={{ color: 'red' }}>*</span></InputLabel>
                                    <OutlinedInput
                                        label="# Of Users"
                                        id="standard-adornment-password"
                                        type='number'
                                        value={userCount || ''}
                                        onChange={(e) => {
                                            const newErrors = errors;
                                            if (e.target.value) {
                                                newErrors.userCount = '';
                                            } else {
                                                newErrors.userCount = 'Please provide # of user';
                                            }
                                            setErrors(newErrors);
                                            setUserCount(e.target.value)
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.keyCode === 38 || event.keyCode === 40) {
                                                event.preventDefault();
                                            }
                                        }}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.userCount}</Typography>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2">Start Date</Typography>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <OutlinedInput
                                        id="standard-adornment-password"
                                        type='date'
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant="body2">End Date</Typography>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <OutlinedInput
                                        id="standard-adornment-password"
                                        type='date'
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                    />
                                </FormControl>
                            </Grid>
                            {(planId?.name === 'Supplier' || planId?.label === 'Supplier') && (
                                <Grid item xs={12} md={6}>
                                    <Autocomplete
                                        value={manufacturerData.filter((c) => suppliers?.includes(c.product_provider_id)) || []}
                                        id="checkboxes-tags-demo"
                                        size="small"
                                        fullWidth
                                        multiple
                                        clearIcon={true}
                                        disableCloseOnSelect
                                        options={manufacturerData}
                                        getOptionLabel={(option) => option?.name}
                                        ListboxProps={{
                                            onScroll: (event) => loadNextManufacturer(event),
                                        }}
                                        renderOption={(props, option, { selected }) => {
                                            const { key, ...optionProps } = props;
                                            return (
                                                <li key={key} {...optionProps}>
                                                    <Checkbox
                                                        icon={icon}
                                                        checkedIcon={checkedIcon}
                                                        style={{ marginRight: 8 }}
                                                        checked={selected}
                                                    />
                                                    {option?.name}
                                                </li>
                                            );
                                        }}
                                        onChange={(event, newValue) => {
                                            const newErrors = errors;
                                            if (newValue.length > 0) {
                                                newErrors.suppliers = '';
                                            } else {
                                                newErrors.suppliers = 'Please select a supplier';
                                            }
                                            setErrors(newErrors);
                                            setSupplier(newValue.map((a) => a.product_provider_id))
                                            setManufacturerPage(1);
                                        }}
                                        inputValue={inputValue === 0 || inputValue === 'on' ? '' : inputValue}
                                        onInputChange={(e) => {
                                            if (e) {
                                                setInputValue(e.target.value);
                                                if (e?.target?.value?.length >= 1) {
                                                    setManufacturerPage(1);
                                                    getManufacturerData(1, e?.target?.value);
                                                }
                                            }
                                        }}
                                        renderInput={(params) =>
                                            <TextField
                                                fullWidth
                                                {...params}
                                                label="Supplier *"
                                                name="supplier"
                                                variant="outlined"
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <>
                                                            {manufacturerLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                            {params.InputProps.endAdornment}
                                                        </>
                                                    ),
                                                }}
                                            />}
                                    />
                                    <Typography variant='body2' style={{ color: 'red' }}>{errors.suppliers}</Typography>
                                </Grid>
                            )}
                            {(!['Student', 'Supplier'].includes(planId?.name) && !['Student', 'Supplier'].includes(planId?.label)) && (
                                <Grid item xs={12} md={6}>
                                    <FormGroup>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={isProcurementAssign}
                                                    onClick={(e) => {
                                                        setIsProcurementAssign(e.target.checked);
                                                    }}
                                                />}
                                            label="Assign Procurement"
                                        />
                                    </FormGroup>
                                </Grid>
                            )}
                            <Grid item xs={12}>
                                <DataTable
                                    height='50vh'
                                    columnDefs={[
                                        {
                                            headerName: 'License Name',
                                            field: 'plan_name',
                                            minWidth: 340,
                                            width: 340,
                                            hide: false,
                                            filter: false,
                                            sortable: false,
                                            resizable: true
                                        },
                                        {
                                            headerName: '# of Users',
                                            field: 'user_limit',
                                            minWidth: 100,
                                            width: 100,
                                            hide: false,
                                            filter: false,
                                            sortable: false,
                                            resizable: true
                                        },
                                        {
                                            headerName: 'Start Date',
                                            field: 'start_date',
                                            minWidth: 120,
                                            width: 120,
                                            hide: false,
                                            filter: false,
                                            sortable: false,
                                            resizable: true,
                                            cellRenderer: (params) => {
                                                return (
                                                    <span>{params?.data?.start_date ? moment(params?.data?.start_date).format('DD-MM-YYYY') : '--'}</span>
                                                )
                                            }
                                        },
                                        {
                                            headerName: 'End Date',
                                            field: 'end_date',
                                            minWidth: 120,
                                            width: 120,
                                            hide: false,
                                            filter: false,
                                            sortable: false,
                                            resizable: true,
                                            cellRenderer: (params) => {
                                                return (
                                                    <span>{params?.data?.end_date ? moment(params?.data?.end_date).format('DD-MM-YYYY') : '--'}</span>
                                                )
                                            }
                                        },
                                        {
                                            headerName: 'Status',
                                            field: 'status',
                                            minWidth: 120,
                                            width: 120,
                                            hide: false,
                                            filter: false,
                                            sortable: false,
                                            resizable: true,
                                            cellRenderer: (params) => {
                                                return (
                                                    <span>{params?.data?.status === 'active' ? 'Active' : 'In Active'}</span>
                                                )
                                            }
                                        },
                                    ]}
                                    rowData={rowData}
                                    rowsPerPage={10}
                                    singleClickEdit={false}
                                    modelType="clientSide"
                                />
                            </Grid>
                        </Grid>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" color="secondary"
                        onClick={() => {
                            setActivetab(0);
                            setOrganizationId(null);
                            setDialogOpen(false);
                            setErrors({});
                            setOrgWebsite(null);
                            setSupplier([]);
                            setOrganizationName(null);
                            setOrganizationType(null);
                            setOrgPhone(null);
                            setPlanId(null);
                            setUserCount(0);
                            setIsProcurementAssign(false);
                            setStartDate(new Date().toISOString().split('T')[0]);
                            setEndDate(new Date().toISOString().split('T')[0]);
                            setSubscriptionId(null);
                            setRowData([]);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            try {
                                if (activetab === 0) {
                                    const newErrors = {};
                                    if (!organizationName) {
                                        newErrors.organizationName = 'Organization Name is required';
                                    }
                                    if (!organizationType) {
                                        newErrors.organizationType = 'Organization Type is required';
                                    }
                                    setErrors(newErrors);
                                    if (Object.keys(newErrors).length === 0) {
                                        const data = {
                                            "org_name": organizationName,
                                            "org_phone_number": orgPhone,
                                            "org_type": organizationType,
                                            "org_website": orgWebsite,
                                        }
                                        if (organizationId) {
                                            setDataLoding(true);
                                            const response = await apiRequest('put', `/organization/${organizationId}`, data);
                                            if (response?.data) {
                                                setDataLoding(false);
                                                showNotification(response?.data?.message, 'success');
                                                setActivetab(1);
                                                setErrors({});
                                                onGridReady({
                                                    api: gridApi
                                                });
                                            }
                                        } else {
                                            setDataLoding(true);
                                            const response = await apiRequest('post', `/admin/organization`, data);
                                            if (response?.data) {
                                                setDataLoding(false);
                                                showNotification(response?.data?.message, 'success');
                                                setOrganizationId(response?.data?.data?.organization_id);
                                                setActivetab(1);
                                                setErrors({});
                                                setOrgWebsite(null);
                                                setOrganizationName(null);
                                                setOrganizationType(null);
                                                setOrgPhone(null);
                                                onGridReady({
                                                    api: gridApi
                                                });
                                            }
                                        }
                                    }
                                } else {
                                    if (activetab === 1 && organizationId) {
                                        const newErrors = {};
                                        if (!planId) {
                                            newErrors.plan = 'Please select license';
                                        }
                                        if (userCount === 0) {
                                            newErrors.userCount = 'Please provide # of user';
                                        }
                                        if (planId?.name === 'Supplier' || planId?.label === 'Supplier') {
                                            if (suppliers.length === 0) {
                                                newErrors.suppliers = 'Please select a supplier';
                                            }
                                        }
                                        setErrors(newErrors);
                                        if (Object.keys(newErrors).length === 0) {
                                            const data = {
                                                "plan_id": planId?.plan_id || planId?.value,
                                                "plan_name": planId?.name || planId?.label,
                                                "user_limit": Number(userCount),
                                                "start_date": startDate,
                                                "end_date": endDate,
                                                "status": "active",
                                                "organization_id": organizationId,
                                                "is_procurement_assign": isProcurementAssign
                                            }
                                            if (subscriptionId) {
                                                setDataLoding(true);
                                                const response = await apiRequest('put', `/subscription/${subscriptionId}`, data);
                                                if (response?.data) {
                                                    setDataLoding(false);
                                                    showNotification(response?.data?.message, 'success');
                                                    setActivetab(0);
                                                    setOrganizationId(null);
                                                    setSubscriptionId(null);
                                                    setPlanId(null);
                                                    setUserCount(0);
                                                    setIsProcurementAssign(false);
                                                    setDialogOpen(false);
                                                    setStartDate(new Date().toISOString().split('T')[0]);
                                                    setEndDate(new Date().toISOString().split('T')[0]);
                                                    setErrors({});
                                                    setRowData([]);
                                                    onGridReady({
                                                        api: gridApi
                                                    });
                                                }
                                            } else {
                                                setDataLoding(true);
                                                const response = await apiRequest('post', `/subscription`, data);
                                                if (response?.data) {
                                                    setDataLoding(false);
                                                    showNotification(response?.data?.message, 'success');
                                                    setActivetab(0);
                                                    setOrganizationId(null);
                                                    setSubscriptionId(null);
                                                    setPlanId(null);
                                                    setUserCount(0);
                                                    setIsProcurementAssign(false);
                                                    setDialogOpen(false);
                                                    setStartDate(new Date().toISOString().split('T')[0]);
                                                    setEndDate(new Date().toISOString().split('T')[0]);
                                                    setErrors({});
                                                    setRowData([]);
                                                    onGridReady({
                                                        api: gridApi
                                                    });
                                                }
                                            }
                                            if (suppliers.length > 0) {
                                                await apiRequest('post', '/admin/save-org-suppliers', {
                                                    user_id: user?.user_id,
                                                    organization_id: organizationId,
                                                    product_provider_ids: suppliers
                                                });
                                                setSupplier([]);
                                            }
                                        }
                                    } else {
                                        showNotification('Before granting access, you need to create the organization.', 'error');
                                    }
                                }
                            } catch (error) {
                                setDataLoding(false);
                                showNotification(error?.response?.data.error || error.message, 'error');
                            }
                        }}
                    >
                        {activetab === 1 ? 'Save' : 'Next'}
                    </Button>
                </DialogActions>
            </Dialog>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <DemoTabs
                    value={activeTab}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    <DemoTab
                        label="User Access"
                        value={0}
                        onClick={() => {
                            setActiveTab(0);
                        }} />
                    <DemoTab
                        label="Custom Fields"
                        value={1}
                        onClick={() => {
                            setActiveTab(1);
                        }} />
                    <DemoTab
                        label="Import Data"
                        value={2}
                        onClick={() => {
                            setActiveTab(2);
                        }} 
                    />
                </DemoTabs>
            </Box>
            {activeTab === 0 && (
                <>
                    <Box display="flex" justifyContent="space-between" mt={1} mb={1}>
                        <Box>
                            <Typography variant='h4' style={{ fontWeight: 'bold' }}>Organizations</Typography>
                        </Box>
                        <Box>
                            <Tooltip title="Download User List">
                                <IconButton
                                    onClick={async () => {
                                        const response = await apiRequest('get', `/admin/all-users`);
                                        const { data } = response.data;

                                        const formattedData = data.map((item) => ({
                                            "First Name": item.first_name,
                                            "Last Name": item.last_name,
                                            "Email": item?.email,
                                            "Phone Number": item?.phone_number || '--',
                                            "Role": roles.find((a) => a.id === item?.role_id)?.name,
                                            "Status": item?.is_deleted ? 'Block' : item?.is_inactive ? 'Temporary Block' : 'Active',
                                            "Organization Name": item?.organization?.org_name || '--',
                                            "Organization Type": item?.organization?.org_type || '--',
                                            "Organization Phone Number": item?.organization?.org_phone_number || '--',
                                            "Org Status": item.organization?.is_deleted ? 'Deleted' : item?.organization?.Subscriptions?.[0]?.plan_id ? 'Active' : 'InActive',
                                            "License Name": item?.organization?.Subscriptions?.[0]?.plan_name || '--',
                                            "Start Date": item?.organization?.Subscriptions?.[0]?.start_date ? moment(item?.organization?.Subscriptions?.[0]?.start_date).format('DD-MM-YYYY') : '--',
                                            "End Date": item?.organization?.Subscriptions?.[0]?.end_date ? moment(item?.organization?.Subscriptions?.[0]?.end_date).format('DD-MM-YYYY') : '--',
                                            "# Of Max Users": item?.organization?.Subscriptions?.[0]?.user_limit || '--'
                                        }));

                                        const worksheet = XLSX.utils.json_to_sheet(formattedData);

                                        const workbook = XLSX.utils.book_new();
                                        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

                                        const excelBuffer = XLSX.write(workbook, {
                                            bookType: "xlsx",
                                            type: "array"
                                        });

                                        const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
                                        saveAs(fileData, "User List.xlsx");
                                    }}
                                >
                                    <CloudDownloadOutlinedIcon color="primary" />
                                </IconButton>
                            </Tooltip>
                            <TextField
                                size="small"
                                id="outlined-search"
                                type="text"
                                placeholder="Search Organizations"
                                sx={{
                                    background: '#ebeaea',
                                    marginRight: 1,
                                }}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon fontSize="small" />
                                        </InputAdornment>
                                    ),
                                    endAdornment: (
                                        searchingText && ( // Show the clear icon only if there's text in the field
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => {
                                                        setSearchText('');
                                                        onGridReady({
                                                            api: gridApi,
                                                            searchingText: ''
                                                        });
                                                    }}
                                                >
                                                    <ClearIcon fontSize="small" />
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    ),
                                }}
                                value={searchingText}
                                onChange={(e) => setSearchText(e.target.value)}
                                onKeyPress={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault();
                                        onGridReady({
                                            api: gridApi,
                                            searchingText: e.target.value
                                        });
                                    }
                                }}
                            />
                            {isUser?.code === 'mvedasMasterAdmin' && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="medium"
                                    startIcon={<Add />}
                                    style={{
                                        height: 40
                                    }}
                                    onClick={() => {
                                        setDialogOpen(true);
                                    }}
                                >
                                    Create
                                </Button>
                            )}
                        </Box>
                    </Box>
                    <DataTable
                        height='74vh'
                        columnDefs={updatedColumns}
                        rowsPerPage={rowsPerPage}
                        onGridReady={onGridReady}
                        onPaginationChanged={onPaginationChanged}
                        singleClickEdit={false}
                        modelType="infinite"
                    />
                </>
            )}
            {activeTab === 1 && (
                <CustomField />
            )}
            {activeTab === 2 && (
                <ImportData />
            )}
        </>
    )
}

export default SoftwareAdminPanel;